module.exports = __webpack_public_path__ + "static/media/explore.b299898a.svg";